var React = require('react');
var createReactClass = require('create-react-class');
var ReactRedux = require('react-redux');
var bindActionCreators = require('redux').bindActionCreators;
var PropTypes = require('prop-types');
var { getSubdomain } = require('../../modules/practice/practiceUtils');

const PracticeActions = require('../../modules/practice/actions/practice');

var checkSubdomain = function (Component) {
  var CheckedSubdomain = createReactClass({
    componentDidMount: function () {
      const subdomain = getSubdomain();

      if (subdomain && subdomain !== 'staging') {
        this.props.setPracticeFromSubdomain(subdomain);
      }
    },

    render: function () {
      return <Component {...this.props} />;
    },
  });

  CheckedSubdomain.propTypes = {
    practice: PropTypes.object,
  };

  var mapStateToProps = function (state) {
    return {
      practice: state.practice,
    };
  };

  var mapDispatchToProps = function (dispatch) {
    return bindActionCreators(Object.assign({}, PracticeActions), dispatch);
  };

  return ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
  )(CheckedSubdomain);
};

module.exports = checkSubdomain;



// WEBPACK FOOTER //
// ./src/common/routes/subdomain/checkSubdomain.jsx